function makeFormPersistent(form) {
    const formId = form.getAttribute('id');
    if (!formId) return; // Formulář musí mít ID

    const storageKey = 'form-' + formId;

    // Obnovení dat
    const savedData = JSON.parse(localStorage.getItem(storageKey) || '{}');
    for (const [key, value] of Object.entries(savedData)) {
        const input = form.elements.namedItem(key);
        if (!input) continue;

        if (input.type === 'checkbox') {
            setTimeout(() => {
                input.checked = value === 'true';
                if (input.checked) {
                    input.dispatchEvent(new Event('click'));
                }
            }, 50);
        } else if (input.type === 'radio') {
            if (input.value === value) input.checked = true;
        } else if (input.tagName === 'SELECT') {
            input.value = value;
            input.dispatchEvent(new Event('change'));

        } else {
            input.value = value;
        }
    }

    // Ukládání při změně
    form.addEventListener('input', () => {
        const data = {};
        for (const element of form.elements) {
            if (!element.name) continue;

            if (element.type === 'checkbox') {
                data[element.name] = element.checked.toString();
            } else if (element.type === 'radio') {
                if (element.checked) data[element.name] = element.value;
            } else {
                data[element.name] = element.value;
            }
        }
        localStorage.setItem(storageKey, JSON.stringify(data));
        console.log('Form data saved to localStorage:', data);
    });

    // Vyčištění při odeslání
    form.addEventListener('submit', () => {
        localStorage.removeItem(storageKey);
    });
}

// Inicializace
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#frm-orderForm').forEach(form => {
        makeFormPersistent(form);
    });
});
